/**
 * Payment control / account number from USSD instructions (e.g. 90902OEI69G9).
 * Prefer the full control number over the short booking reference.
 */
export function extractPaymentControlNumber(instructions, bookingRef = '') {
  const text = String(instructions || '').trim();
  const ref = String(bookingRef || '').trim();
  if (!text) return ref;

  const labeled = text.match(
    /(?:payment\s+reference\s*(?:no\.?|number)?|account\s*(?:\/?\s*reference)?|control\s*(?:no\.?|number)?|namba\s+ya\s+malipo|rejea)\s*[:\-–]?\s*([A-Z0-9]{6,})/i
  );
  if (labeled?.[1]) return labeled[1].trim();

  if (ref) {
    const escaped = ref.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const longer = text.match(new RegExp(`\\b([A-Z0-9]*${escaped})\\b`, 'i'));
    if (longer?.[1] && longer[1].length > ref.length) {
      return longer[1].trim();
    }
  }

  return ref;
}
